// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"864":"245fac0d","2013":"245fac0d","4039":"245fac0d","8098":"245fac0d"}[chunkId] + ".chunk.css";
};